<div class="nested-modifier-outer-container">
  <div class="nested-modifier-inner-container">
    <div
      class="nested-modifier-content"
      *ngIf="(selectedNestedModifierGroups$ | async)?.length"
    >
      <ng-container
        *ngFor="
          let modifierGroup of selectedNestedModifierGroups$ | async;
          last as isLast;
          trackBy: uiService.stdEntityIdTrackByFn
        "
      >
        <div class="nested-modifier-content-header">
          <v2-body-small-text [color]="'dark-grey'" [lineClamp]="2">
            <span>{{
              modifierGroup.guestInstructions || modifierGroup.title
            }}</span>
          </v2-body-small-text>
          <v2-icon
            class="nested-modifier-edit-icon"
            icon="edit"
            color="primary"
            (click)="openSheet(modifierGroup)"
          ></v2-icon>
        </div>
        <v2-body-text>
          <ul>
            <ng-container
              *ngFor="
                let selection of modifierGroup.modifiers;
                trackBy: uiService.stdEntityIdTrackByFn
              "
            >
              <li class="nested-modifier-selection">
                <v2-body-text [color]="'primary'">•</v2-body-text>
                <div
                  class="nested-modifier-selection-quantity"
                  *ngIf="selection.maximumQty !== 1"
                >
                  ×{{ selection.quantity }}
                </div>
                <v2-body-text
                  class="nested-modifier-name"
                  [color]="'black'"
                  [lineClamp]="1"
                >
                  {{ selection.name }}
                </v2-body-text>
                <v2-body-text
                  class="nested-modifier-name"
                  [color]="'dark-grey'"
                  [lineClamp]="1"
                  *ngIf="selection.price > 0"
                >
                  (
                  <span *ngIf="selection.price > 0">+</span>
                  {{ selection.price | v2Currency }} ea)
                </v2-body-text>
              </li>
            </ng-container>
          </ul>
        </v2-body-text>
        <v2-divider
          class="nested-selection-divider"
          [inset]="true"
          *ngIf="!isLast && modifierGroup.parentMod === this.modifier"
        ></v2-divider>
      </ng-container>
    </div>
    <v2-row
      *ngIf="isSelectionInvalid$ | async"
      class="nested-modifier-selection-required modifier-card invalid"
      (click)="openUnfilledSheet()"
    >
      <v2-column class="nested-modifier-selection-required-label-container">
        <v2-body-small-text [color]="'alert-orange'">
          <span>{{ requiredSelectionText$ | async }}</span>
        </v2-body-small-text>
        <v2-body-text
          class="nested-modifier-selection-required-label"
          [color]="'alert-orange'"
        >
          <i>Selection Required</i>
        </v2-body-text>
      </v2-column>
      <v2-center class="nested-modifier-select-button">
        <v2-body-text
          class="nested-modifier-select-button-label"
          [color]="'alert-orange'"
        >
          SELECT
        </v2-body-text>
        <v2-icon
          class="nested-modifier-select-icon"
          icon="disclosure-right"
          color="alert-orange"
        ></v2-icon>
      </v2-center>
    </v2-row>
  </div>
  <v2-row
    class="nested-modifier-selection-available"
    *ngIf="
      !(selectedNestedModifierGroups$ | async)?.length &&
      !(isSelectionInvalid$ | async)
    "
    (click)="openTopLevelSheet()"
  >
    <v2-column class="nested-modifier-selection-available-label-container">
      <v2-body-text
        class="nested-modifier-selection-required-label"
        [color]="'darkest-grey'"
      >
        <i>Optional selections available</i>
      </v2-body-text>
    </v2-column>
    <v2-center class="nested-modifier-select-button">
      <v2-body-text
        class="nested-modifier-select-button-label"
        [color]="'darkest-grey'"
      >
        SELECT
      </v2-body-text>
      <v2-icon
        class="nested-modifier-select-icon"
        icon="disclosure-right"
        color="darkest-grey"
      ></v2-icon>
    </v2-center>
  </v2-row>
</div>
